/*
 * @Desc: 
 * @Author: lc
 * @Date: 2024-09-21 10:21:41
 * @LastEditors: lc
 * @LastEditTime: 2024-09-21 10:24:04
 */
/**
  * 部门 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const itemtype = {
    // 列表
    list (params) {
        return axios.get(api + 'itemtype/list', { params: params })
    },
    // 添加
    create (params) {
        return axios.post(api + 'itemtype/create', qs.stringify(params))
    },
    // 修改
    edit (params) {
        return axios.post(api + 'itemtype/edit', qs.stringify(params))
    },
    // 修改状态
    status (params) {
        return axios.post(api + 'itemtype/status', qs.stringify(params))
    },
    sort (params) {
        return axios.post(api + 'itemtype/sort', qs.stringify(params))
    },
    // 删除
    remove (params) {
        return axios.post(api + 'itemtype/remove', qs.stringify(params))
    },
    detail (params) {
        return axios.get(api + 'itemtype/detail', { params: params })
    },
    select (params) {
        return axios.get(api + 'itemtype/select', { params: params })
    },
}


// 导出接口
export default itemtype
